import React from 'react';

const TextField = ({
  label,
  value = '',
  onChange,
  type = 'text',
  placeholder = '',
  name,
  error = '',
  prefix,
  postfix,
  required,
  ...props
}) => {
  return (
    <div className="form-control w-full mb-4">
      {label && (
        <label className="label flex">
          <span className="text-sm font-semibold text-start px-1">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </span>
        </label>
      )}
      <div className={`input bg-transparent border border-gray-700 focus-within:border-gray-400 focus-within:outline-none w-full p-2 ${error ? 'input-error' : ''}`}>
      {
        prefix && (<div className='p-2'>{prefix}</div>)
      }
      <input
        type={type}
        name={name}
        value={type === 'file' ? undefined : value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        {...props}
      />
      {
        postfix && (<div>{postfix}</div>)
      }
      </div>
      {error && (
        <label className="label flex self-start">
          <span className="label-text-alt text-sm m-1 text-error">{error}</span>
        </label>
      )}
    </div>
  );
};

export default TextField;
